<template>
  <div style="margin-bottom: 170px">
    <!-- Tab -->
    <BuTab></BuTab>
    <!-- Block -->
    <div class="block">
      <!-- top search bar -->
      <div class="px-5 pt-5 mb-10px d-flex">
        <div class="form-input-group flex-grow-1 mr-5">
          <div class="prepend-icon"><v-icon>search</v-icon></div>
          <input
            type="text"
            class="pl-42px"
            placeholder="搜尋"
            v-model="filter.keyword"
          />
        </div>
        <button class="btn btn-primary w-88px" @click="getProducts">搜尋</button>
      </div>
      <!-- second bar -->
      <div class="d-flex px-5 mb-5">
        <!-- 篩選BU  -->
        <FilterBU v-model="filter.buIds" v-if="currentBuTabId === ''"></FilterBU>
        <!-- 篩選分類/子分類 -->
        <FilterCategory
          :selectedCategoriesFromParent.sync="selectedCategories"
          :selectedSubCategoriesFromParent.sync="selectedSubcategories"
        ></FilterCategory>
        <!-- 篩選顯示/隱藏 -->
        <TableControlShowState v-model="filter.status"></TableControlShowState>
        <!-- 上架中/下架中 -->
        <SegmentalControls
          class="mr-2"
          :buttons="statusOptions"
          v-model="filter.mainStatus"
          itemStyle="style-basic"
        ></SegmentalControls>
      </div>
      <!-- third bar -->
      <div
        class="px-5 mb-5 d-flex"
        v-if="
          filter.buIds.length != 0 ||
            selectedCategories.length != 0 ||
            selectedSubcategories.length != 0
        "
      >
        <div
          class="h5 ink-02-medium--text h-32px w-70px d-flex align-center flex-shrink-0"
        >
          篩選條件：
        </div>
        <div class="flex-wrap">
          <!-- filter bu -->
          <v-chip
            close
            class="ml-5 mb-2"
            v-for="(id, indexOfBU) in filter.buIds"
            :key="id"
            @click:close="filter.buIds.splice(indexOfBU, 1)"
          >
            {{ selectBuName(id) }}
          </v-chip>
          <!-- filter category -->
          <v-chip
            close
            class="ml-5 mb-2"
            v-for="(cat, indexOfCat) in selectedCategories"
            :key="`cat${cat.id}`"
            @click:close="selectedCategories.splice(indexOfCat, 1)"
          >
            {{ cat.name }}
          </v-chip>
          <!-- filter subcategory -->
          <v-chip
            close
            class="ml-5 mb-2"
            v-for="(subcat, indexOfSubcat) in selectedSubcategories"
            :key="`subcat${subcat.id}`"
            @click:close="selectedSubcategories.splice(indexOfSubcat, 1)"
          >
            {{ subcat.name }}
          </v-chip>
        </div>
      </div>

      <v-simple-table>
        <template v-slot:default>
          <thead>
          <div v-if="lengthOfisCheckedList > 0"
               class="form-item d-flex align-center px-5 h-60px batch">
            <h5 class="col-checkbox">
              <v-checkbox
                v-model="checkAllStatus"
                :indeterminate="indeterminate"
                @click="changeAllCheckbox"
              ></v-checkbox>
            </h5>
            <h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>
            <div>
              <button class="btn btn-danger mr-10px" @click="multiDelete">
                <v-icon color="white" class="mr-2">delete</v-icon>
                <span>刪除</span>
              </button>
            </div>
            <div>
              <button class="btn mr-10px" @click="changePublish(true)">設為顯示</button>
            </div>
            <div>
              <button class="btn" @click="changePublish(false)">設為隱藏</button>
            </div>
          </div>
          <tr>
              <th>
                <v-checkbox
                  v-model="checkAllStatus"
                  :indeterminate="indeterminate"
                  @click="changeAllCheckbox"
                ></v-checkbox>
              </th>
              <th class="text-left">Pic</th>
              <th class="text-left">Product Name</th>
              <th class="text-left">BU</th>
              <th class="text-left">Order</th>
              <th class="text-left">ID</th>
              <th class="text-left">顯示/隱藏</th>
              <th class="text-left">產品下架</th>
              <th class="text-left">編輯</th>
              <th class="text-left">刪除</th>
            </tr>
          </thead>
          <tbody>
          <tr
            v-for="item in products"
            :key="item.id"
          >
            <td>
              <v-checkbox v-model="item.isChecked"></v-checkbox>
            </td>
            <td>
              <div
                class="w-40px h-40px bg-cover bg-center"
                :style="{
                  'background-image': `url(${item.image})`,
                }"
              ></div>
            </td>
            <td>
              <div>{{ item.name }}</div>
              <div class="ink-02-medium--text mt-1">
                {{
                `${item.category} / ${item.subcategory} / ${item.model_name}`
                }}
              </div>
            </td>
            <td>{{ item.bu }}</td>
            <td>{{ item.order }}</td>
            <td>{{ item.id }}</td>
            <td>
              <FormSwitch
                v-model="item.trans_status"
                @changeStatus="changePublish(item.trans_status, item.id)">
              </FormSwitch>
            </td>
            <td>
              <div v-if="item.status">
                <button
                  class="btn btn-outlined"
                  :style="{
                    color: '#f60000',
                    border: 'solid 1px #f60000',
                  }"
                  @click="changeMainPublish(false, item.id)"
                >
                  下架
                </button>
              </div>
              <div v-else>
                <button class="btn btn-outlined"
                        @click="changeMainPublish(true, item.id)">重新上架</button>
              </div>
            </td>
            <td>
              <button class="btn square" @click="toProductEdit(item.id)">
                <v-icon>edit</v-icon>
              </button>
            </td>
            <td>
              <deleteDialog @confirm-delete="deleteItem(item.id)"></deleteDialog>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>

      <!-- table footer -->
      <Pagination @handleNextPreEvent="getProducts" model="product"></Pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TableControlShowState from '@/components/TableControlShowState.vue';
import FormSwitch from '@/components/FormSwitch.vue';
import BuTab from '@/components/BuTab.vue';

import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';
import FilterBU from '@/views/C-3__Products/c/C-3a__ProductList_FilterBU.vue';
import FilterCategory from '@/views/C-3__Products/c/C-3b__ProductList_FilterCategory.vue';
import SegmentalControls from '@/components/SegmentalControls.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  components: {
    TableControlShowState,
    FormSwitch,
    deleteDialog,
    FilterBU,
    FilterCategory,
    SegmentalControls,
    Pagination,
    BuTab,
  },
  data: () => ({
    statusOptions: [{
      value: 1,
      title: '上架中',
    }, {
      value: 0,
      title: '已下架',
    }],
    selectedCategories: [],
    selectedSubcategories: [],
    checkAllStatus: false, // left top checkbox status
  }),
  computed: {
    ...mapState(['buTabs', 'currentBuTabId']),
    ...mapState('product', ['products', 'filter']),
    lengthOfisCheckedList() {
      return this.products.filter((item) => item.isChecked)
        .length;
    },
    indeterminate() {
      const isCheckedList = this.products.filter(
        (item) => item.isChecked,
      );
      if (
        isCheckedList.length === 0 ||
        isCheckedList.length === this.products.length
      ) {
        return false;
      }
      return true;
    },
    isCheckedListIds() {
      return this.products.filter((item) => item.isChecked).map((item) => item.id);
    },
  },
  watch: {
    lengthOfisCheckedList(newValue) {
      if (newValue < this.products.length) {
        this.checkAllStatus = false;
      }
      if (newValue === this.products.length) {
        this.checkAllStatus = true;
      }
    },
    selectedCategories(newValue) {
      this.filter.categoryIds = newValue.map((o) => o.id);
    },
    selectedSubcategories(newValue) {
      this.filter.subcategoryIds = newValue.map((o) => o.id);
    },
    currentBuTabId(newValue) {
      this.filter.buId = newValue;
      if (newValue) {
        this.filter.buIds = [];
        this.selectedCategories = [];
        this.selectedSubcategories = [];
      }
      this.getProducts();
    },
  },
  methods: {
    ...mapActions('product', {
      getProducts: 'find',
      setFilter: 'setFilter',
      destroyProduct: 'destroy',
      publish: 'publish',
      mainPublish: 'mainPublish',
    }),
    toProductEdit(id) {
      this.$router.push({
        name: 'ProductInfoEdit',
        params: { id },
      });
    },
    changeAllCheckbox() {
      if (this.checkAllStatus) {
        this.products.forEach(
          (item) => (item.isChecked = true),
        );
      } else {
        this.products.forEach(
          (item) => (item.isChecked = false),
        );
      }
    },
    changePublish(status, id) {
      this.publish({
        ids: id ? [id] : this.isCheckedListIds,
        status,
      }).then(() => {
        this.getProducts();
      });
    },
    changeMainPublish(status, id) {
      this.mainPublish({
        ids: id ? [id] : this.isCheckedListIds,
        status,
      }).then(() => {
        this.getProducts();
      });
    },
    async deleteItem(id) {
      await this.destroyProduct(id).then(() => {
        this.getProducts();
      });
    },
    async multiDelete() {
      await this.isCheckedListIds.forEach((id) => {
        this.destroyProduct(id).then(() => {});
      });
      this.getProducts();
    },
    selectBuName(id) {
      const bu = this.buTabs.find((o) => o.id === id);
      return bu.name || '';
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-pic {
    width: 40px;
    margin-right: 20px;
  }
  .col-product-name {
    min-width: 280px;
    margin-right: 20px;
  }
  .col-bu {
    min-width: 131px;
    margin-right: 11px;
  }
  .col-order {
    width: 39px;
    margin-right: 40px;
    text-align: right;
  }
  .col-id {
    width: 53px;
    text-align: right;
  }
  .col-show {
    margin-right: 10px;
  }
  .col-onstore-status {
    display: flex;
    justify-content: center;
    width: 93px;
  }
}

.v-chip {
  background-color: #f7fafc !important;
  border: solid 1px #d7dee7;
}
</style>
